export default __webpack_public_path__ + "static/media/404-not-found.ad88a2a9.svg";